import React from 'react';
import {
  MdDashboard,
  MdOutlineRoute,
  MdOutlineTour,
  MdOutlineDescription,
  MdOutlineDataThresholding,
  MdHelpOutline,
} from 'react-icons/md';
import MenuItem from './MenuItem';

export default {
  title: 'Components/Navbar/MenuItem',
  component: MenuItem,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    backgroundColor: { control: 'color' },
  },
};

export const Dashboard = {
  args: {
    isNavbarExpanded: true,
    icon: <MdDashboard size={24} color="#44AC5C" />,
    title: 'Dashboard',
    link: '#',
  },
};

export const Routes = {
  args: {
    isNavbarExpanded: true,
    icon: <MdOutlineRoute size={24} color="#44AC5C" />,
    title: 'Routes',
    link: '#',
  },
};

export const Visits = {
  args: {
    isNavbarExpanded: true,
    icon: <MdOutlineTour size={24} color="#44AC5C" />,
    title: 'Visits',
    link: '#',
  },
};

export const Notes = {
  args: {
    isNavbarExpanded: true,
    icon: <MdOutlineDescription size={24} color="#44AC5C" />,
    title: 'Notes',
    link: '#',
  },
};

export const ImportsReports = {
  args: {
    isNavbarExpanded: true,
    icon: <MdOutlineDataThresholding size={24} color="#44AC5C" />,
    title: 'Data Tools',
    link: '#',
  },
};

export const Help = {
  args: {
    isNavbarExpanded: true,
    icon: <MdHelpOutline size={24} color="#44AC5C" />,
    title: 'Help',
    link: '#',
  },
};
